import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeadphones: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHeadphones"><Path d="M3.5 13.5V12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12V13.5M3.5 13.5V20.5H7.5V13.5H3.5ZM20.5 13.5V20.5H16.5V13.5H20.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHeadphones;
